import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-export-sftp',
  templateUrl: './help-add-export-sftp.component.html',
  styleUrls: ['./help-add-export-sftp.component.scss']
})
export class HelpAddExportSftpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
